import { BUTTON_STYLES } from "./buttonStyles";
import { TYPOGRAPHY_STYLES } from "./typographyStyles";
import { THEME_COLORS } from "../util/themes";

export const PAGINATION_STYLES = {
    "& .MuiPagination-ul": {
        gap: 1,
    },

    "& .MuiPaginationItem-root": {
        ...TYPOGRAPHY_STYLES.rubikMedium,
        fontWeight: 700,
        textTransform: "uppercase",
        borderRadius: 0,

        height: 32,
        minWidth: 32,
        padding: "0 10px",

        backgroundColor: "background.paper",
        border: `1px solid ${THEME_COLORS.greyLight}`,
        borderBottom: (BUTTON_STYLES.primary as any).borderBottom,
        boxShadow: 1,

        color: (BUTTON_STYLES.primary as any).color,
        position: "relative",
        overflow: "hidden",
        transition: `color 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s ease`,

        "&::before": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "0%",
            backgroundColor: (BUTTON_STYLES.primary as any).color,
            transition: "height 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        },

        "&:hover": {
            color: "white",
            boxShadow: 2,
            "&::before": { height: "100%" },
        },

        "&.Mui-selected": {
            backgroundColor: (BUTTON_STYLES.primary as any).color,
            color: "white",
            borderColor: (BUTTON_STYLES.primary as any).color,
            borderBottom: "none",
            boxShadow: 2,
            "&::before": { display: "none" },
        },

        "&.Mui-selected:hover": {
            backgroundColor: (BUTTON_STYLES.primary as any).color,
            color: "white",
            boxShadow: 3,
        },

        "&.Mui-disabled": {
            opacity: 0.45,
            boxShadow: "none",
        },
    },

    "& .MuiPaginationItem-ellipsis": {
        ...TYPOGRAPHY_STYLES.rubikMedium,
        color: (BUTTON_STYLES.primary as any).color,
        opacity: 0.7,
        height: 32,
        minWidth: 32,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
} as const;

export const PAGE_SIZE_SELECT_STYLES = {
    formControl: {
        minWidth: 120,

        "& .MuiInputLabel-root": {
            ...TYPOGRAPHY_STYLES.rubikSmall,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.3px",
            color: "text.secondary",
        },

        "& .MuiOutlinedInput-root": {
            height: (BUTTON_STYLES.compact as any).height ?? "32px",
            borderRadius: 0,

            backgroundColor: "background.paper",
            border: `1px solid ${THEME_COLORS.greyLight}`,
            borderBottom: (BUTTON_STYLES.primary as any).borderBottom,
            boxShadow: 1,

            color: (BUTTON_STYLES.primary as any).color,

            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
            },

            "& .MuiSelect-select": {
                ...TYPOGRAPHY_STYLES.rubikMedium,
                fontSize: (BUTTON_STYLES.compact as any).fontSize ?? "12px",
                fontWeight: 700,
                textTransform: "uppercase",
                padding: "6px 34px 6px 12px",
                lineHeight: 1.2,
                color: "inherit",
            },

            "& .MuiSvgIcon-root": {
                color: "inherit",
            },

            "&:hover": {
                boxShadow: 2,
            },
            "&.Mui-focused": {
                boxShadow: 2,
            },
        },

    },

    menuPaper: {
        borderRadius: 0,
        border: `1px solid ${THEME_COLORS.greyLight}`,
        mt: 0.5,
        boxShadow: 2,
    },


    menuList: {
        py: 0,
    },

    menuItem: {
        ...TYPOGRAPHY_STYLES.rubikMedium,
        fontSize: (BUTTON_STYLES.compact as any).fontSize ?? "12px",
        fontWeight: 700,
        textTransform: "uppercase",
        color: (BUTTON_STYLES.primary as any).color,
        minHeight: 40,

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },

        "&.Mui-selected": {
            backgroundColor: (BUTTON_STYLES.primary as any).color,
            color: "white",
        },
        "&.Mui-selected:hover": {
            backgroundColor: (BUTTON_STYLES.primary as any).color,
            color: "white",
        },
    },
} as const;














